import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Plus } from "lucide-react";
import { useT } from "@/i18n/LangProvider";

export default function Faq() {
  const { t, lang } = useT();
  const faqs = t("faq.items") || [];

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="section"
      style={{ background: "var(--navy-light)" }}
    >
      <div className="section-inner max-w-[800px]">
        <p className="eyebrow fade-up">{t("faq.eyebrow")}</p>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-4 mb-12 fade-up">
          {t("faq.title1")}{" "}
          <em className="text-[color:var(--gold-light)]">
            {t("faq.title_em")}
          </em>
        </h2>

        <Accordion type="single" collapsible className="w-full" key={lang}>
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="fade-up"
              style={{ borderBottom: "1px solid rgba(184,150,46,0.18)" }}
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="faq-trigger hover:no-underline group [&>svg]:hidden">
                <span className="flex-1 pr-4">{f.q}</span>
                <Plus
                  className="w-5 h-5 text-[color:var(--gold-light)] transition-transform duration-300 group-data-[state=open]:rotate-45 flex-shrink-0"
                  strokeWidth={1.5}
                />
              </AccordionTrigger>
              <AccordionContent className="faq-content">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
